import { motion } from 'motion/react'
import { Lightbulb, Sparkles, Target, TrendingUp } from 'lucide-react'
import { Badge } from '@/components/ui'
import { whyChooseUs } from '@/data/company'

const icons = [Lightbulb, Sparkles, Target, TrendingUp]

export function WhyChooseUs() {
  return (
    <section className="section-padding relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-accent-500/5 via-transparent to-electric-500/5" />
      
      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <Badge className="mb-4">Why UC Advisors</Badge>
          <h2 className="text-display-md md:text-display-lg font-heading font-bold text-white mb-4">
            Your Strategic Partner in Business Excellence
          </h2>
          <p className="text-lg text-slate-400 max-w-3xl mx-auto">
            Our mission is to revolutionize the way businesses operate by delivering cutting-edge solutions that leverage the latest advancements in technology and strategic thinking.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {whyChooseUs.map((item, index) => {
            const Icon = icons[index % icons.length]
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="glass-card-hover p-8 rounded-2xl group"
              >
                <div className="flex gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-accent-500/20 to-electric-500/20 flex items-center justify-center group-hover:from-accent-500/30 group-hover:to-electric-500/30 transition-colors">
                      <Icon className="w-7 h-7 text-accent-400" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-heading font-semibold text-white mb-3 group-hover:text-accent-400 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}


